import { useNavigate } from "react-router-dom";
import {
    MenuOutlined,
} from '@ant-design/icons';
import { useEffect, useState } from "react";
import { blockSession } from '@/features/homepage/api/ApiBlockSession';
import logoCCBJI from "@/assets/img/2800_CCBJI_Logo.bmp";
import logoFVJ from "@/assets/img/2801_FVJ_Logo.bmp";
import { COMPANY_CODE, RESPONSE_ERR } from "@/constant";
import storage from "@/utils/storage";
import { Button } from "antd";

export type HeaderProps = {
    toggleMenu: any;
    modeLogin: boolean;
    nameUser: any;
    vkorg: any;
};


export const Header = ({ toggleMenu, modeLogin, nameUser, vkorg }: HeaderProps) => {

    const [isLogin, setIsLogin] = useState(false)
    const navigate = useNavigate();
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 799);
    const getType = JSON.parse(window.localStorage.getItem(`dpds_type`) || 'null') ? JSON.parse(window.localStorage.getItem(`dpds_type`) || 'null') : null;

    useEffect(() => {
        setIsLogin(modeLogin);
        const handleResize = () => {
            setIsDesktop(window.innerWidth >= 799);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const goLogin = () => {
        if (getType == RESPONSE_ERR.E0104) {
            return
        } else if (getType == RESPONSE_ERR.E0105) {
            return
        } else {
            navigate('/');
        }
    }

    let logoCompany = logoCCBJI
    if (vkorg) {
        if (vkorg == COMPANY_CODE.FVJ) {
            logoCompany = logoFVJ;
        } else {
            logoCompany = logoCCBJI;
        }
    }

    const handleButtonLogout = async () => {
        const data_request = {
            access_token: storage.getToken(),
            refresh_token: storage.getRefreshToken(),
            dlv_place_cd: storage.getId(),
        };

        storage.clearAll();
        navigate('/login');
        blockSession(data_request).catch(() => { });
    };


    if (isLogin) {
        return (
            <nav className={`${isDesktop ? 'header' : ''} navbar navbar-expand-lg navbar-light bg-white justify-content-between`} >
                {isDesktop && (
                    <li className="navbar-nav ms-auto" onClick={goLogin} style={{
                        width: '180px', borderRight: '1px solid lightgrey', cursor: 'pointer',
                        boxShadow: 'rgba(0, 0, 0, 0.15) 2px 0px 4px'
                    }}>
                        <img src={logoCompany} alt={logoCompany} style={{ height: '77px', width: '178px', margin: 'auto' }} />
                    </li>
                )}
                <button className="btn bg-white border-0 sidemenu-toggle-icon" style={{ color: '#007bff', outline: 'none' }} onClick={toggleMenu} >
                    <MenuOutlined />
                </button>
                <ul className="navbar-nav ms-auto">

                    <li className="nav-item d-flex " style={{ height: '35px' }}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="#007bff"
                            className="h-10 w-10 text-primary-color-blue custom-span"
                            height={40}
                            width={40}
                        >
                            <path
                                fillRule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                                clipRule="evenodd"
                            />
                        </svg>
                        <div className="d-flex justify-content-center align-items-center text-left">
                            <span className="text-dark mr-3 justify-content-center align-items-center text-left custom-span"
                                style={{ fontSize: '13px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                                data-bs-toggle="tooltip"
                                title={nameUser}
                            >
                                {nameUser}
                            </span>
                        </div>
                        <Button className="btn btn-primary p-2" type="primary"
                            style={{ height: '2.5rem', width: '7rem' }}
                            onClick={() => {
                                handleButtonLogout();
                            }}
                        >
                            <span>ログアウト</span>
                        </Button>
                    </li>
                </ul>
            </nav >
        );
    }
    else {
        return (
            <nav className="navbar navbar-expand-lg navbar-light justify-content-start bg-white" >
                <ul className="navbar-nav ms-auto">
                    <li className="nav-item d-flex justify-content-around" onClick={goLogin} style={{ height: '35px' }}>
                        <img className="m-1" src={vkorg === "0803" ? logoFVJ : logoCCBJI} alt="Logo 1" style={{ height: '35px' }} />
                    </li>
                </ul>
            </nav >
        );
    }
};
